// extracted by mini-css-extract-plugin
export default {"reactionEmoji":"style_reactionEmoji__455jy","reactionUser":"style_reactionUser__STEzE"};